var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWallboxActive = function SvgWallboxActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    xmlSpace: "preserve"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#656565",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.023,
    cy: 40,
    r: 9.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.523.511V55.5h31V.511h-31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.523 4.509V23.5h23V4.509h-23zM37.523 4.509h1.999V23.5h-1.999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.753 7.773s14.911-2.619 7.804 14.164c-1.575 3.721-6.851 8.73-.321 17.208 4.084 5.303-4.081 11.009-9.657 4.695M23.773 33.5l-5.25 7.429h3.5l-1.75 5.571 5.25-7.43h-3.5z"
  }))));
};
export default SvgWallboxActive;